<template>
    <crud-create
        :open="open"
        :loading="loading"
        :title="title"
        :errorMessage="errorMessage"
        @create="create"
        @close="$emit('close')"
    >
        <company-form ref="form" v-model="form" :input-errors="inputErrors" />
    </crud-create>
</template>

<script>
import CompanyProvider from "../../../providers/CompanyProvider";

import { CrudCreate } from "@dracul/common-frontend";
import { ClientError } from "../../../../../errors";

import CompanyForm from "../CompanyForm";

export default {
    name: "CompanyCreate",

    components: { CompanyForm, CrudCreate },

    props: {
        open: { type: Boolean, default: true },
    },

    data() {
        return {
            title: "admin.company.creating",
            errorMessage: "",
            inputErrors: {},
            loading: false,
            form: {
                razonSocial: null,
                cuit: null,
                nombreFantasia: null,
                direccion: null,
                telefono: null,
                emailComercial: null,
                emailContacto: null,
                planId: null,
                envioEmailHabilitado: true,
            },
        };
    },

    methods: {
        create() {
            if (this.$refs.form.validate()) {
                this.loading = true;
                // Convert afipPuntoVenta to number if it exists
                const formData = {
                    ...this.form,
                    afipPuntoVenta: this.form.afipPuntoVenta ? parseInt(this.form.afipPuntoVenta) : null
                };
                CompanyProvider.createCompany(formData)
                    .then((r) => {
                        if (r) {
                            this.$emit("itemCreated", r.data.companyCreate);
                            this.$emit("close");
                        }
                    })
                    .catch((error) => {
                        let clientError = new ClientError(error);
                        this.inputErrors = clientError.inputErrors;
                        this.errorMessage = clientError.i18nMessage;
                    })
                    .finally(() => (this.loading = false));
            }
        },
    },
};
</script>

<style scoped></style>
